import { useEffect, useState } from 'react';
import {
    Button,
    CircularProgress,
    TextField,
    Card,
    CardContent,
    Typography,
    Divider,
    useTheme,
    Grid
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@mui/system';
import { getIndividalSection } from '../../../../API/Section';
import {
    createManual,
    deleteManual,
    editManualApi
} from '../../../../API/Lesson';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DeleteIcon from '@mui/icons-material/Delete';
import Dialogue from '../Components/Dialogue';
import { resetCurrentScreenForm } from '../Slices/currentScreen';

const Manual = () => {
    const loader = useSelector((state) => state?.currentScreen?.isLoading);
    const [manualValue, setManual] = useState('');
    const [open, setOpen] = useState();
    const [manualError, setManualError] = useState({
        isError: false,
        message: ''
    });
    const editManual = useSelector((state) => state?.currentScreen?.editable);
    const shouldResetManual = useSelector(
        (state) => state?.currentScreen?.resetForm
    );
    const sectionId = useSelector((state) => state?.currentScreen?.id);
    const courseId = useSelector((state) => state?.currentCourse?.data?._id);
    const dispatch = useDispatch();
    const theme = useTheme();

    const handleManual = (e) => {
        e.target.value === ''
            ? setManualError({
                  isError: true,
                  message: 'Manual Title is required'
              })
            : setManualError({
                  isError: false,
                  message: ''
              });
        setManual(e.target.value.replace(/^\s+/, ''));
    };

    const handleDeleteManual = async () => {
        await deleteManual(sectionId, dispatch);
        setOpen(false);
    };

    const submitManual = async (e) => {
        console.log('CourseId in redux', courseId);
        if (manualValue === '' || !manualValue) {
            setManualError({
                isError: true,
                message: 'Manual Title is required'
            });
        } else {
            editManual
                ? await editManualApi(sectionId, manualValue, dispatch)
                : await createManual(courseId, manualValue, dispatch);
            dispatch(resetCurrentScreenForm(false));
            toast.success('Manual saved successfully');
        }
    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        if (editManual) {
            getIndividalSection(sectionId).then((response) =>
                setManual(response)
            );
        }
    }, [sectionId]);

    useEffect(() => {
        shouldResetManual && setManual('');
    }, [shouldResetManual]);

    return (
        <>
            {loader ? (
                <Box
                    textAlign="center"
                    height="40vh"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                >
                    <CircularProgress />
                </Box>
            ) : (
                <Box>
                    <Card
                        elevation={3}
                        sx={{
                            borderRadius: '16px',
                            border: `1px solid ${theme.palette.divider}`,
                            overflow: 'hidden',
                            mb: 2
                        }}
                    >
                        {/* Header Details */}
                        <Box
                            sx={{
                                p: 3,
                                backgroundColor: theme.palette.primary.main,
                                color: '#fff',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 2
                            }}
                        >
                            <Box>
                                <Typography
                                    variant="h5"
                                    sx={{ fontWeight: 700, mb: 0.5 }}
                                >
                                    {editManual
                                        ? 'Manual Settings'
                                        : 'Create New Manual'}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    sx={{ opacity: 0.8 }}
                                >
                                    {editManual
                                        ? 'Update section title or delete this manual from the course database.'
                                        : 'Add a new manual folder section to organize lessons and assessments.'}
                                </Typography>
                            </Box>
                        </Box>

                        <Divider />

                        <CardContent sx={{ p: 4 }}>
                            <Box display="flex" flexDirection="column" gap={3}>
                                <Typography
                                    variant="subtitle2"
                                    sx={{
                                        fontWeight: 600,
                                        color: 'text.secondary'
                                    }}
                                >
                                    Manual Title
                                </Typography>

                                <Grid container spacing={2} alignItems="center">
                                    <Grid item xs={12} sm={editManual ? 7 : 9}>
                                        <TextField
                                            label="Manual / Section Title"
                                            name="manual"
                                            fullWidth
                                            value={manualValue}
                                            variant="outlined"
                                            onChange={handleManual}
                                            error={Boolean(manualError.isError)}
                                            helperText={
                                                manualError.isError &&
                                                manualError.message
                                            }
                                        />
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        sm={editManual ? 5 : 3}
                                        display="flex"
                                        gap={1.5}
                                        sx={{ height: '100%' }}
                                    >
                                        <Button
                                            onClick={(e) => submitManual(e)}
                                            variant="contained"
                                            color="secondary"
                                            sx={{
                                                height: '100%',
                                                fontWeight: 'bold',
                                                textTransform: 'none',
                                                borderRadius: '8px'
                                            }}
                                        >
                                            {editManual
                                                ? 'Save Title'
                                                : 'Add Section'}
                                        </Button>
                                        {editManual && (
                                            <Button
                                                variant="outlined"
                                                color="error"
                                                onClick={handleClickOpen}
                                                sx={{
                                                    minWidth: '56px',
                                                    height: '100%',
                                                    borderRadius: '8px'
                                                }}
                                            >
                                                <DeleteIcon />
                                            </Button>
                                        )}
                                    </Grid>
                                </Grid>
                            </Box>
                        </CardContent>
                    </Card>

                    <Dialogue
                        open={open}
                        handleClose={handleClose}
                        name="Manual"
                        handleDelete={handleDeleteManual}
                    />
                    <ToastContainer />
                </Box>
            )}
        </>
    );
};

export default Manual;
